import type { TenantConfig } from '@/types/TenantConfig'

export const serpentine: TenantConfig = {
  logo: 'assets/serpentine/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBorder: '1px solid #000000',
    },
    mobileFooter: {
      cartButtonBorder: '2px solid #000000',
      cartButtonIconColor: '#000000',
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  ticketureTheme: true,
  teaserImageSize: {
    width: 360,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/serpentine/static/images/success.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    eventDetailRoute: {
      eventNameTitlePosition: 'inside content',
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Checkout',
      },
      completedOrdersRoute: {
        ticketsOrderNumber: 'Your Booking Order Number is {number}',
      },
    },
  },
}
